import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10" }
const _hoisted_4 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px","flex":"1 1 auto"}
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
  type: "button",
  "data-bs-toggle": "modal",
  "data-bs-target": "#companyModal",
  style: {"background-color":"#EB9355"}
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_18 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_19 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_27 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_31 = { class: "fw-bold" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "mt-15 mt-md-0" }
const _hoisted_34 = { class: "pagination mb-0" }
const _hoisted_35 = {
  key: 0,
  class: "page-item"
}
const _hoisted_36 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "page-item"
}
const _hoisted_39 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_40 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = { class: "modal-title fs-5" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_46 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_47 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_48 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_53 = ["placeholder"]
const _hoisted_54 = { class: "invalid-feedback" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-12" }
const _hoisted_57 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_58 = ["placeholder"]
const _hoisted_59 = { class: "invalid-feedback" }
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import {ref, onMounted,reactive,inject } from "vue";
import axios from 'axios';
import { useI18n } from "vue-i18n";
import { useTableFilter } from "../../utils/UseTablefilter";
import router from '../../router/index'
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import { useRouter } from 'vue-router';
import * as yup from 'yup';
declare interface TypeFree {
  id : string,
  code: string,
  name: string,
  description: string, 
  status:string
  }
 
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TypeFreeContent',
  setup(__props) {

const backApi=inject('back');
// const page = ref(1);
// const total = ref(0);
// const pagesLeft = ref(0);
// const currentPage = ref(0);
// const numPages = ref(0);
const { t } = useI18n();


let token: string|null = localStorage.getItem('login_token');

const errors = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    description: "",  
    name: ""   
  });

  
  const schema = yup.object({    
      description: yup.string().required('La description est requise'),  
      name: yup.string().required('Le nom du pays est requis'),   
     
  });


const typefees =ref(new Array<TypeFree>());
  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const {
  searchQuery,
  paginatedData: paginatedTypeFees,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  typefees,
  [
    (t: any) => t.code,
    (t: any) => t.name,
    (t: any) => t.description,
    (t: any) => t.status,
  ],
  15
);
const getTypeFees = (arg=1) =>{
    // +arg
    axios.get(backApi+'/secure/typefees/',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        typefees.value = response.data;  //.data.typefees            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        // total.value=10;
        // page.value=1;
        // pagesLeft.value=0;
        // currentPage.value=1;
        // numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const changeStatus =(status,code)=>{
 // alert(code)
  axios.put(`${backApi}/secure/typefees/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const storeTypeFree =()=>{
try {  
  schema.validateSync(formValues);
  axios.post(`${backApi}/secure/typefees/new`,{          
          description:formValues.description,
          name:formValues.name
          
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          router.go();  
        }      
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


onMounted(() => { 
  checkSessionValidate(1)
  getTypeFees();
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                type: "text",
                class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                placeholder: "Rechercher..."
              }, null, 512), [
                [_vModelText, _unref(searchQuery)]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(current_permissions)('create_typefee'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t('feeTypes.createFeeType')) + " ", 1),
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('feeTypes.code')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('feeTypes.name')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('feeTypes.description')), 1),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('feeTypes.status')), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedTypeFees), (typefee) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: typefee.id
                    }, [
                      _createElementVNode("td", _hoisted_14, _toDisplayString(typefee.code), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(typefee.name), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(typefee.description), 1),
                      _createElementVNode("td", _hoisted_17, [
                        (typefee.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('feeTypes.active')), 1))
                          : _createCommentVNode("", true),
                        (typefee.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('feeTypes.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _cache[13] || (_cache[13] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_22, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('status_typeFee'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(typefee.status,typefee.code))
                                  }, [
                                    _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (typefee.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.$t('feeTypes.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (typefee.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.$t('feeTypes.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_23))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                        _createTextVNode(_toDisplayString(_ctx.$t('feeTypes.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(page)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                        _createTextVNode(_toDisplayString(_ctx.$t('feeTypes.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_33, [
                    _createElementVNode("ul", _hoisted_34, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[14] || (_cache[14] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_36, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_37))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(storeTypeFree, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("h1", _hoisted_43, _toDisplayString(_ctx.$t('feeTypes.feeType')), 1),
              _cache[16] || (_cache[16] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_44, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                    _createElementVNode("h6", _hoisted_46, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("h6", _hoisted_48, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('feeTypes.name')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('feeTypes.namePlaceholder'),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_53), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_54, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('feeTypes.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('feeTypes.descriptionPlaceholder'),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[8] || (_cache[8] = ($event: any) => (validate('description')))
                      }, "                    ", 42, _hoisted_58), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_59, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              (_unref(current_permissions)('create_typefee '))
                ? (_openBlock(), _createElementBlock("button", _hoisted_61, [
                    _cache[17] || (_cache[17] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('feeTypes.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ])
  ], 64))
}
}

})